import { createFileRoute } from '@tanstack/react-router';
import { Maintenance } from '../components/error/Maintenance';

export const Route = createFileRoute('/maintenance')({
  component: Maintenance,
});
